import React from 'react';
import { TabPaneProps } from 'antd/es/tabs';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

interface LoginTabProps extends TabPaneProps {
  active?: boolean;
}

const LoginTab: React.FC<LoginTabProps> & {
  typeName: string;
} = (props) => {
  const { children } = props;
  return <TabPane {...props}>{props.active && children}</TabPane>;
};

// Flagbit is used to judge whetherCustom component
LoginTab.typeName = 'LoginTab';

export default LoginTab;
